import React, { useState } from 'react';
import './Chat.css';
import Sidebar from './sidebar';

const Chat = () => {
  const [users, ] = useState(['ТОО АКС', 'ЖК форс', 'ИП Нил']); // Список пользователей
  const [search, setSearch] = useState(''); // Поисковой запрос
  const [selectedUser, setSelectedUser] = useState(null); // Выбранный пользователь для чата
  const [messages, setMessages] = useState({}); // Сообщения по пользователям
  const [newMessage, setNewMessage] = useState('');

  const handleUserSelect = (user) => {
    setSelectedUser(user);
    if (!messages[user]) {
      setMessages({ ...messages, [user]: [] });
    }
  };

  const handleNewMessageChange = (event) => {
    setNewMessage(event.target.value);
  };

  const handleSendMessage = () => {
    if (newMessage.trim() !== '') {
      const userMessages = messages[selectedUser] || [];
      const updatedMessages = {
        ...messages,
        [selectedUser]: [...userMessages, { text: newMessage, timestamp: new Date() }],
      };
      setMessages(updatedMessages);
      setNewMessage('');
    }
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSendMessage();
    }
  };

  const filteredUsers = users.filter((user) =>
    user.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="chat-container">
      <Sidebar />
      <div className="chat-sidebar">
        <div className="search-chat">
          <input
            type="text"
            value={search}
            onChange={handleSearchChange}
            placeholder="Поиск..."
            className="chat-input"
          />
        </div>
        <div className="users-list">
          {filteredUsers.map((user) => (
            <div
              key={user}
              onClick={() => handleUserSelect(user)}
              className={`user ${selectedUser === user ? 'active' : ''}`}
            >
              <div className="user-avatar" style={{ backgroundImage: `url(https://via.placeholder.com/40)` }}></div>
              <div className="user-info">
                <div className="user-name">{user}</div>
                <div className="user-last-message">Последнее сообщение...</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="chat-messages">
        {selectedUser && (
          <>
            <div className="chat-header">
              <div className="chat-user-avatar" style={{ backgroundImage: `url(https://via.placeholder.com/40)` }}></div>
              <div className="chat-user-name">{selectedUser}</div>
            </div>
            <div className="messages">
              {messages[selectedUser]?.map((message, index) => (
                <div key={index} className={`message ${index % 2 === 0 ? 'sent' : 'received'}`}>
                  <div className="message-text">{message.text}</div>
                  <div className="message-timestamp">{new Date(message.timestamp).toLocaleTimeString()}</div>
                </div>
              ))}
            </div>
            <div className="chat-input">
              <input
                type="text"
                value={newMessage}
                onChange={handleNewMessageChange}
                onKeyPress={handleKeyPress}
                placeholder="Напишите сообщение..."
              />
              <button onClick={handleSendMessage}><i className="fa fa-paper-plane"></i></button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Chat;
